<template>
  <div
    v-if="opentoworkDialogVisible"
    class="gc-shared-opentowork-box__wrapper"
    v-click-outside="hideOpentoworkDialog"
  >
    <div class="gc-shared-opentowork-box__header">
      Open to Work

      <gc-opentowork-switch
        class="gc-shared-opentowork-box__switch"
      ></gc-opentowork-switch>
    </div>

    <div class="gc-shared-opentowork-box__body">
      Show recruiters and the Community that you’re interested in employment and
      freelance opportunities. Make sure your specialization and skills are up
      to date on your profile.
    </div>
  </div>
</template>

<script>
import gcOpentoworkSwitch from "./gcOpentoworkSwitch";

export default {
  name: "gcOpentoworkDialog",
  components: {
    gcOpentoworkSwitch,
  },
  computed: {
    opentoworkDialogVisible() {
      return Grabcad.opentoworkStore.state.opentoworkDialogVisible;
    },
  },
  methods: {
    hideOpentoworkDialog(event) {
      if ([...event.target.classList].includes("opentoworkStatusIcon")) return;
      Grabcad.opentoworkStore.commit("hideOpentoworkDialog");
    },
  },
};
</script>
